export class WebListaAtas {
    idAta : number;
    nmTitulo : string;
    nmDescricao : string;
    dtCadastro : Date;
 }